export const replaceVerificationNumber = function (inputField) {
    var allInputs = document.querySelectorAll(".verification-code-input");

    if (inputField === undefined || inputField === null) {
        return;

    }

    var currentValue = inputField.value;

    if (currentValue.length === 6) {

        for (var i = 0; i < currentValue.length; i++) {

            allInputs[i].value = parseInt(currentValue.charAt(i))
        }
    } else {
        if (!(currentValue.charAt(1) === "")) {
            inputField.value = currentValue.charAt(1);
        }
    }

    if (!(allInputs[parseInt(inputField.getAttribute("data-input-place"))+1] === undefined)) {
        allInputs[parseInt(inputField.getAttribute("data-input-place"))+1].focus()
    }
}
